import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Table, Form, Input, FormGroup, Label, Button, FormText } from 'reactstrap';

class HodsonSalto extends Component {
    static displayName = HodsonSalto.name;

    constructor(props) {
        super(props)
        const date = new Date()
        this.state = {
            permissionFlag: true,
            userInfo: this.props.reduxData.userInfo,
            tableData: [],
            dateStart: date.getFullYear() + "-" + date.getMonth() + "-" + date.getDate(),
            dateEnd: (date.getFullYear() + 1) + "-" + date.getMonth() + "-" + date.getDate(),
            timeStart: date.toLocaleTimeString('en-US', {
                hour12: false,
                hour: "numeric",
                minute: "numeric"
            }),
            timeEnd: date.toLocaleTimeString('en-US', {
                hour12: false,
                hour: "numeric",
                minute: "numeric"
            }),
            formPCID: "",
            pcidName: "",
            secondFormActive: false,
            formSun: false,
            formMon: false,
            formTue: false,
            formWed: false,
            formThu: false,
            formFri: false,
            fromSat: false
        }
        this.apiFetch('ValidDepartments', { pagepk: "/HodsonSalto" }, "permissionFlag")
    }

    async apiFetch(url, body, stateItem) {
        this.props.updateFetchTime()
        let toSend = {
            userLevel: this.props.reduxData.userInfo.level.pk,
            ...body
        }
        const response = await fetch(url, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Authorization': this.props.reduxData.apiKey },
            body: JSON.stringify(toSend)
        })
        const data = await response.json()
        console.log("data: " , data)
        this.setState({
            [stateItem]: data
        }, () => {
            if (url == "ValidDepartments" && data == true) {
                this.apiFetch("HodsonSaltoGetData", {}, "tableData")
            }
            if (url == "HodsonSaltoStuLookup") {
                this.setState({
                    pcidName: data.stuName
                })
            }
        })
    }

    formChange(e,field, pk) {
        e.preventDefault()
        //console.log("event: ", e)
        //for checkboxes, val = e.target.checked; else, val = e.target.value
        let newVal
        if (field == "startdate" || field == "enddate" || field == "starttime" || field == "endtime") {
            newVal = e.target.value
        }
        else {
            newVal = e.target.checked ? "true" : "false"
        }
        //console.log("ready to transmit: ", {field: field, val: newVal})
        this.apiFetch("HodsonSaltoUpdateField",{ field: field, val: newVal, pk: pk },"tableData")
    }

    updatePCID(pcid) {
        this.setState({
            formPCID: pcid
        })
        if (pcid.length == 10) {
            this.apiFetch("HodsonSaltoStuLookup", { stuPCID: pcid }, "pcidName")
        }
        else {
            this.setState({
                pcidName: ""
            })
        }
    }

    formSubmit(e, order) {
        const date = new Date()
        e.preventDefault()
        if (order == 1) {
            this.setState({
                secondFormActive: true
            })
        } 
        if (order == 2) {
            let thisFormData = {
                pcid: this.state.formPCID,
                startdate: this.state.dateStart,
                enddate: this.state.dateEnd,
                starttime: this.state.timeStart,
                endtime: this.state.timeEnd,
                sun: this.state.formSun,
                mon: this.state.formMon,
                tue: this.state.formTue,
                wed: this.state.formWed,
                thu: this.state.formThu,
                fri: this.state.fromFri,
                sat: this.state.formSat
            }
            this.apiFetch("HodsonSaltoAddRecord", thisFormData, "tableData")
            this.setState({
                secondFormActive: false,
                formPCID: "",
                dateStart: date.getFullYear() + "-" + date.getMonth() + "-" + date.getDate(),
                dateEnd: (date.getFullYear() + 1) + "-" + date.getMonth() + "-" + date.getDate(),
                timeStart: date.toLocaleTimeString('en-US', {
                    hour12: false,
                    hour: "numeric",
                    minute: "numeric"
                }),
                timeEnd: date.toLocaleTimeString('en-US', {
                    hour12: false,
                    hour: "numeric",
                    minute: "numeric"
                }), 
                formSun: false,
                formMon: false,
                formTue: false,
                formWed: false,
                formThu: false,
                formFri: false,
                fromSat: false
            })
        }
    }

    deleteThis(pk) {

    }

    render() {
        if (this.state.permissionFlag == false) {
            this.props.passNewPage(-1);
        }
        //console.log("tableData: ", this.state.tableData)
        
        return (<div>
            <Form inline className="d-flex" onSubmit={(e) => this.formSubmit(e, 1)}>
                <FormGroup>
                    <Label>PCID</Label>
                    <Input type="text" id="pcid" name="pcid" value={this.state.formPCID} disabled={this.state.secondFormActive} onChange={(e) => this.updatePCID(e.target.value)} />
                    {this.state.pcidName.length > 2 && <FormText>{this.state.pcidName}</FormText>}
                </FormGroup>
                &ensp;&ensp;
                <FormGroup>
                    <Label>Start Date</Label>
                    <Input type="date" id="startdate" name="startdate" value={this.state.dateStart} disabled={this.state.secondFormActive} onChange={(e) => this.setState({ dateStart: e.target.value })} />
                </FormGroup>
                &ensp;&ensp;
                <FormGroup>
                    <Label>End Date</Label>
                    <Input type="date" id="enddate" name="enddate" value={this.state.dateEnd} disabled={this.state.secondFormActive} onChange={(e) => this.setState({ dateEnd: e.target.value })} />
                </FormGroup>
                &ensp;&ensp;
                <FormGroup>
                    <Label>Start Time</Label>
                    <Input type="time" id="starttime" name="starttime" value={this.state.timeStart} disabled={this.state.secondFormActive} onChange={(e) => this.setState({ timeStart: e.target.value })} />
                </FormGroup>
                &ensp;&ensp;
                <FormGroup>
                    <Label>End Time</Label>
                    <Input type="time" id="endtime" name="endtime" value={this.state.timeEnd} disabled={this.state.secondFormActive} onChange={(e) => this.setState({ timeEnd: e.target.value })} />
                </FormGroup>
                &ensp;&ensp;
                { !this.state.secondFormActive && <Button color="success" type="submit" id="firstSubmit" name="firstSubmit" onClick={(e) => this.formSubmit(e, 1)}>Next</Button>}
            </Form>
            <br />
            { this.state.secondFormActive && < Form inline className="d-flex" onSubmit={(e) => this.formSubmit(e,2) }>
                <FormGroup>
                    <Input type="checkbox" id="formSun" name="formSun" checked={this.state.formSun} onClick={() => this.setState({formSun: !this.state.formSun}) } />
                    <Label>Sunday</Label>
                </FormGroup>
                &ensp;&ensp;
                <FormGroup>
                    <Input type="checkbox" id="formMon" name="formMon" checked={this.state.formMon} onClick={() => this.setState({ formMon: !this.state.formMon })} />
                    <Label>Monday</Label>
                </FormGroup>
                &ensp;&ensp;
                <FormGroup>
                    <Input type="checkbox" id="formTue" name="formTue" checked={this.state.formTue} onClick={() => this.setState({ formTue: !this.state.formTue })} />
                    <Label>Tuesday</Label>
                </FormGroup>
                &ensp;&ensp;
                <FormGroup>
                    <Input type="checkbox" id="formWed" name="formWed" checked={this.state.formWed} onClick={() => this.setState({ formWed: !this.state.formWed })} />
                    <Label>Wednesday</Label>
                </FormGroup>
                &ensp;&ensp;
                <FormGroup>
                    <Input type="checkbox" id="formThu" name="formThu" checked={this.state.formThu} onClick={() => this.setState({ formThu: !this.state.formThu })} />
                    <Label>Thursday</Label>
                </FormGroup>
                &ensp;&ensp;
                <FormGroup>
                    <Input type="checkbox" id="formFri" name="formFri" checked={this.state.formFri} onClick={() => this.setState({ formFri: !this.state.formFri })} />
                    <Label>Friday</Label>
                </FormGroup>
                &ensp;&ensp;
                <FormGroup>
                    <Input type="checkbox" id="formSat" name="formSat" checked={this.state.formSat} onClick={() => this.setState({ formSat: !this.state.formSat })} />
                    <Label>Saturday</Label>
                </FormGroup>
                &ensp;&ensp;
                <Button color="success">Submit</Button>
            </Form>}
            <br />
            {this.state.tableData && <Table>
                <thead>
                    <tr>
                        <th></th>
                        <th></th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.tableData.map(item => (
                        <tr>
                            <td className={"w-25"}>#{item.pk}: {item.name} ({item.pcid})</td>
                            <td>
                                <Form inline>
                                    <FormGroup>
                                        <Form inline className="d-flex">
                                            <FormGroup><Input type="date" name="startdate" id="startdate" defaultValue={item.startdate} onChange={(e) => this.formChange(e, "startdate", item.pk)} /><Label>Start Date</Label></FormGroup>&ensp;&ensp;
                                            <FormGroup><Input type="date" name="enddate" id="enddate" defaultValue={item.enddate} onChange={(e) => this.formChange(e, "enddate", item.pk)} /><Label>End Date</Label></FormGroup>&ensp;&ensp;
                                            <FormGroup><Input type="time" name="starttime" id="starttime" defaultValue={item.starttime} onChange={(e) => this.formChange(e, "starttime", item.pk)} /><Label>Start Time</Label></FormGroup>&ensp;&ensp;
                                            <FormGroup><Input type="time" name="endtime" id="endtime" defaultValue={item.endtime} onChange={(e) => this.formChange(e, "endtime", item.pk)} /><Label>End Time</Label></FormGroup>
                                        </Form>
                                    </FormGroup>
                                    <FormGroup>
                                        <Input type="checkbox" name="sunday" id="sunday" checked={item.sunday == "False" ? false : true} onClick={(e) => this.formChange(e,"sunday",item.pk)} /><Label>Sunday</Label>&ensp;&ensp;&ensp;
                                        <Input type="checkbox" name="monday" id="monday" checked={item.monday == "False" ? false : true} onClick={(e) => this.formChange(e, "monday", item.pk)} /><Label>Monday</Label>&ensp;&ensp;&ensp;
                                        <Input type="checkbox" name="tuesday" id="tuesday" checked={item.tuesday == "False" ? false : true} onClick={(e) => this.formChange(e, "tuesday", item.pk)} /><Label>Tuesday</Label>&ensp;&ensp;&ensp;
                                        <Input type="checkbox" name="wednesday" id="wednesday" checked={item.wednesday == "False" ? false : true} onClick={(e) => this.formChange(e, "wednesday", item.pk)} /><Label>Wednesday</Label>&ensp;&ensp;&ensp;
                                        <Input type="checkbox" name="thursday" id="thursday" checked={item.thursday == "False" ? false : true} onClick={(e) => this.formChange(e, "thursday", item.pk)} /><Label>Thursday</Label>&ensp;&ensp;&ensp;
                                        <Input type="checkbox" name="friday" id="friday" checked={item.friday == "False" ? false : true} onClick={(e) => this.formChange(e, "friday", item.pk)} /><Label>Friday</Label>&ensp;&ensp;&ensp;
                                        <Input type="checkbox" name="saturday" id="saturday" checked={item.saturday == "False" ? false : true} onClick={(e) => this.formChange(e, "saturday", item.pk)} /><Label>Saturday</Label>
                                    </FormGroup>
                                </Form>
                            </td>
                            <td className={"w-10"}><Button color="danger" onClick={() => this.apiFetch("HodsonSaltoDeleteRecord", { pk: item.pk }, "tableData") }>Delete</Button></td>
                        </tr>
                    )) }
                </tbody>
            </Table>}
        </div>)
    }
}

const mapStateTo = state => ({
    reduxData: state
})

const mapDispatchTo = (dispatch) => {
    return {
        updateFetchTime: () => dispatch({ type: 'foundation/setFetchTime' })
    }
}

export default connect(mapStateTo, mapDispatchTo)(HodsonSalto);